import { wrap } from 'comlink';

export function createSmartRouteLogicWorker() {
  try {
    return wrap<typeof import('./worker').default>(
      new Worker(new URL('./worker.ts', import.meta.url))
    );
  } catch (error) {
    console.error('Web Worker not supported');
  }
}
export function transformWorkerResult(
  serializedResult: string
): import('./../swapTypes').EstimateSwapView[] | undefined {
  try {
    return JSON.parse(serializedResult);
  } catch (error) {
    console.error('Error parsing worker result', error);
  }
}
